import type { ReactNode } from "react";
import { Flex, Spin, Typography } from "antd";
import { CacheBuster } from "react-cache-refresh";

import { appVersion, isDevelopment, isProduction } from "@settings";

const { Text, Title } = Typography;

const cacheRefreshLoadingComponent = (
  <Flex
    align="center"
    justify="center"
    style={{
      backgroundColor: "#fff",
      minHeight: "100vh",
      padding: 20,
    }}
    vertical
  >
    <Spin size="large" style={{ marginBottom: 24 }} />

    <Title level={4} style={{ marginBottom: 12, textAlign: "center" }}>
      Verificando versão do sistema...
    </Title>

    <Text
      style={{
        lineHeight: 1.5,
        maxWidth: 400,
        textAlign: "center",
      }}
      type="secondary"
    >
      Estamos garantindo que você utilize a versão mais recente disponível.
    </Text>
  </Flex>
);

export type CacheRefreshProviderProps = {
  children?: ReactNode;
};

export const CacheRefreshProvider = (props: CacheRefreshProviderProps) => {
  const { children } = props;

  if (isDevelopment) {
    return <>{children}</>;
  }

  return (
    <CacheBuster
      currentAppVersion={appVersion}
      hideConsoleLogs={isProduction}
      loadingComponent={cacheRefreshLoadingComponent}
      metaJsonPath="/meta.json"
    >
      {children}
    </CacheBuster>
  );
};
